export enum InteractionEvents {
  // General
  InternalLinkPressed = "Internal Link Pressed",
  TruncateToggled = "Truncate Toggled",
  // FAQ interaction events
  FAQItemPressed = "FAQ Item Pressed",
  // Luggage storage search bar
  LuggageStorageSearchBarSearchPressed = "Luggage Storage Search Bar Search Pressed",
  LuggageStorageSearchBarLocationSuggestionPressed = "Luggage Storage Search Bar Location Suggestion Pressed",
  // Package Acceptance
  PackagesSearchBarSearchPressed = "Packages Search Bar Search Pressed",
  PackagesSearchBarNearMePressed = "Packages Search Bar Near Me Pressed",
  PackageAcceptanceExplainerVideoPlayed = "Package Acceptance Explainer Video Played",
  PackageAcceptancePromoBannerClicked = "Package Acceptance Promo Banner Clicked",
  // Menu
  MenuBurguerClicked = "Menu Burguer Clicked",
  // Featured Stores
  FindClosestLocationPressed = "Find Closest Location Pressed",
  FeaturedStoresStoreCardPressed = "Featured Stores Store Closest Pressed",
  // App download
  DownloadTheAppPressed = "Download The App Pressed",
  PressedAppStoresImages = "Pressed App Stores Images",
  // HomePage Next
  ChangeCheckTimes = "Change Check Times",
  // Datepicker
  DatepickerToggled = "Datepicker Toggled",
  DatepickerCheckInUpdated = "Datepicker Check-in Updated",
  // Reviews
  NextReviewPressed = "Next Review Pressed",
  ReviewCardPressed = "Review Card Pressed",
  // Poi Slider
  NextPoiPressed = "Next Poi Pressed",
  PoiCardPressed = "Poi Card Pressed",
  // Store Slider
  StoreSliderNextPressed = "Store Slider Next Pressed",
  StoreSliderPreviousPressed = "Store Slider Previous Pressed",
  // WhyBounce
  NextWhyBounceValuePropPressed = "Next WhyBounce Value Prop Pressed",
  // Footer
  SocialLinkPressed = "Social Link Pressed",
  SectionViewed = "Section Viewed",
  // Events
  SeeAllEventsPressed = "See All Events Pressed",
  // Luggage Storage Product Banner
  LuggageStorageProductBannerCTAPressed = "Luggage Storage Product Banner CTA Pressed",
  // Luggage Storage Newsletter Banner
  LuggageStorageNewsletterSignedUp = "Luggage Storage Newsletter - Signed Up",
  LuggageStorageNewsletterBookNowCtaPressed = "Luggage Storage Newsletter - Book Now CTA Pressed",
  // Luggage Storage App Sticky Banner
  LuggageStorageAppStickyBannerDismissed = "Luggage Storage App Sticky Banner Dismissed",
  PoiChipPressed = "Poi Chip Pressed",
  // Luggage Storage City & POI Filters
  LuggageStorageFilterClicked = "Luggage Storage Filter Clicked",
  LuggageStorageSortingApplied = "Luggage Storage Sorting Applied",
  LuggageStorageSeeMoreClicked = "Luggage Storage See More Clicked",
  LuggageStoragePoiClicked = "Luggage Storage Poi Clicked",
  // Static map
  StaticMapPressed = "Static Map Pressed",
  // Interactive map
  MapLocationPressed = "Map Location Pressed",
  MapTooltipCtaPressed = "Map Tooltip Cta Pressed",
  // Video
  VideoPlayed = "Video Played",
}
